export const getMaxFloatValue = (prec, deci) =>
  Number.parseFloat(
    // eslint-disable-next-line unicorn/new-for-builtins
    `${[...Array(prec - deci)].map(() => 9).join('')}.${[...Array(deci)]
      .map(() => 9)
      .join('')}`
  );
